module.exports = __webpack_public_path__ + "img/knife_ursus.fed1b2de.svg";